import { createContext } from 'react';
import initialMultimediaState from './initialMultimediaState';

const MultimediaContext = createContext(initialMultimediaState);

export default MultimediaContext;
